import { error, json } from "@sveltejs/kit";
import { p as prisma } from "../../../../chunks/prisma.js";
import { g as getActivePromotions, s as selectBestPromotion } from "../../../../chunks/promotionPricing.js";
const POST = async ({ locals: { user }, request }) => {
  if (!user) throw error(401, "Unauthorized: No user logged in");
  try {
    const req = await request.json();
    const cartOrderItems = req.cartItems;
    if (!Array.isArray(cartOrderItems) || cartOrderItems.length === 0)
      throw error(400, "Invalid cart data: Empty or invalid cart");
    const orderedItems = cartOrderItems.map((item) => ({
      productId: item.product.id,
      quantity: item.quantity
    }));
    const result = await prisma.$transaction(
      async (tx) => {
        const products = await tx.product.findMany({
          where: { id: { in: orderedItems.map((item) => item.productId) } },
          select: {
            id: true,
            name: true,
            price: true,
            quantity: true,
            categories: { select: { id: true } }
          }
        });
        if (products.length !== orderedItems.length) throw error(400, "Some products not found");
        const productMap = new Map(products.map((p) => [p.id, p]));
        const productsNotInStock = orderedItems.filter((item) => {
          const product = productMap.get(item.productId);
          return !product || product.quantity < item.quantity;
        }).map((item) => productMap.get(item.productId)?.name);
        if (productsNotInStock.length > 0)
          throw error(400, `Products out of stock: ${productsNotInStock.join(", ")}`);
        const productIdsForPromos = products.map((p) => p.id);
        const categoryIdsForPromos = Array.from(new Set(products.flatMap((p) => p.categories.map((c) => c.id))));
        const activePromotions = await getActivePromotions(/* @__PURE__ */ new Date(), {
          productIds: productIdsForPromos,
          categoryIds: categoryIdsForPromos
        });
        let totalPrice = 0;
        const orderLinesData = [];
        for (const item of orderedItems) {
          const product = productMap.get(item.productId);
          const categoryIds = product.categories.map((c) => c.id);
          const applied = selectBestPromotion(product.price, product.id, categoryIds, activePromotions);
          const finalUnit = applied ? applied.finalUnitPrice : product.price;
          const discountAmount = applied ? applied.discountAmount : 0;
          totalPrice += finalUnit * item.quantity;
          orderLinesData.push({
            productId: product.id,
            quantity: item.quantity,
            unitPrice: product.price,
            discountAmount,
            promotionId: applied?.promotionId
          });
        }
        const updatePromises = orderedItems.map(
          (item) => tx.product.update({
            where: { id: item.productId },
            data: { quantity: { decrement: item.quantity } }
          })
        );
        await Promise.all(updatePromises);
        const newOrder = await tx.order.create({
          data: {
            userId: user.id,
            totalPrice,
            billRefNumber: req?.billRefNumber,
            ProductOnOrder: {
              createMany: { data: orderLinesData }
            }
          },
          include: {
            ProductOnOrder: true
          }
        });
        return { order: newOrder, totalPrice };
      }
      //  {
      //     timeout: 10000, // 10 second timeout
      //     isolationLevel: 'Serializable' // Highest isolation level for maximum consistency
      // }
    );
    return json({
      message: "Order created successfully",
      order: result.order,
      totalPrice: result.totalPrice
    });
  } catch (e) {
    console.error(e);
    if (e.code === "P2024") {
      throw error(408, "Transaction timeout - please try again");
    }
    if (e.status && e.status !== 500) throw error(e.status, e.body);
    throw error(500, "Internal server error while processing order");
  }
};
export {
  POST
};
